export default function initDocumentToc () {
  const wrappers = document.querySelectorAll('[data-document-toc-wrapper]')

  if (!wrappers.length) {
    return
  }

  wrappers.forEach((wrapper) => {
    if (wrapper.getAttribute('data-document-toc-initialized') === 'true') {
      return
    }

    wrapper.setAttribute('data-document-toc-initialized', 'true')

    const refresh = () => refreshActiveToc(wrapper)

    wrapper.querySelectorAll('[data-toc-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('data-toc-link')
        const target = targetId ? document.getElementById(targetId) : null

        if (!target) {
          return
        }

        event.preventDefault()

        const offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset()

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })

        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + targetId)
        }
      })
    })

    window.addEventListener('scroll', refresh, { passive: true })
    refresh()
  })
}

function refreshActiveToc (wrapper) {
  const context = getTocContext(wrapper)

  if (!context) {
    return
  }

  const headings = Array.from(context.headings)
  const links = Array.from(context.links)

  if (!links.length) {
    return
  }

  let activeId = headings.length ? headings[0].id : null
  const offset = getScrollOffset() + 24

  headings.forEach((heading) => {
    if (heading.getBoundingClientRect().top <= offset) {
      activeId = heading.id
    }
  })

  links.forEach((link) => {
    link.classList.toggle('active', link.getAttribute('data-toc-link') === activeId)
  })
}

function getTocContext (wrapper) {
  if (wrapper.classList.contains('mtt-terms-conditions')) {
    const activeVersion = wrapper.querySelector('.mtt-terms-conditions__category-panel.active .mtt-terms-conditions__version.active')

    if (!activeVersion) {
      return null
    }

    return {
      headings: activeVersion.querySelectorAll('.mtt-terms-conditions__content h2[id]'),
      links: activeVersion.querySelectorAll('[data-toc-link]')
    }
  }

  if (wrapper.classList.contains('mtt-single--legal')) {
    const content = wrapper.querySelector('.mtt-legal__content')

    if (!content) {
      return null
    }

    return {
      headings: content.querySelectorAll('h2[id]'),
      links: wrapper.querySelectorAll('[data-toc-link]')
    }
  }

  return null
}

function getScrollOffset () {
  const header = document.getElementById('main_header')
  const adminBar = document.body.classList.contains('admin-bar') ? 32 : 0

  if (!header) {
    return adminBar + 24
  }

  return header.getBoundingClientRect().height + adminBar
}
